import React, {useState, useEffect} from 'react';
//Material-UI
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {makeStyles} from '@material-ui/styles';
//Icons
import LocalActivityIcon from '@material-ui/icons/LocalActivity';
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp';
//GraphQL
import gql from 'graphql-tag';
import {useMutation} from '@apollo/react-hooks';
//DS
import {hooks} from 'lib.front';
import {validacion} from 'lib.common';
//ESQUEMAS
import {esquemaCampos, esquemaValidacion} from './esquemas';
//
const {useValidacion} = hooks;
const {esVarNullUndef} = validacion;

const useStyles = makeStyles(theme => ({
   root: {
      height: '100%'
   },
   content: {
      padding: 0
   },
   image: {
      height: 48,
      width: 48
   },
   actions: {
      justifyContent: 'flex-end'
   },
   avatar: {
      //backgroundColor: "",
   },
   header: {
      textAlign: 'center',
      spacing: 20,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.h4,
      fontWeight: theme.typography.fontWeightMedium,
      //backgroundColor: theme.palette.background.paper,
      letterSpacing: '0.2px'
   }
}));
/*
Funciones y variables auxiliares globales
*/
const rteDefaultValue = {
   key: 'vacio',
   contenido: ''
};

const msgModalInicial = {
   open: false,
   mensaje: '',
   accionAceptar: false,
   aceptarLabel: 'Eliminar'
};
//Queries
const updateTicket = gql`
   mutation ActualizarTicket($ticket: String!, $estado: Int) {
      actualizarTicket(codigo: $ticket, estado: $estado) {
         codigo
         estado
      }
   }
`;

const GeneralInformacion = props => {
   const classes = useStyles();
   const options = {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric'};
   /*
  Inicializar estados
  */
   const {campos, existeError, handleOnChange, validacionManual, setCampo} = useValidacion(
      esquemaCampos,
      esquemaValidacion
   );

   /**
    * Estados
    */
   const [ticket, setTicket] = useState(props.data || null);

   const [values, setValues] = useState({
      ticket: '',
      estado: 0
   });
   const [msgModal, setMsgModal] = useState(msgModalInicial);
   function handleClose() {
      setMsgModal(msgModalInicial);
   }
   function handleOpen(nuevoMsg) {
      setMsgModal({...msgModal, open: true, mensaje: nuevoMsg});
   }

   /*
  Estados de conexion a la API
  */
   const [procesar, {error: errorP, data: dataP}] = useMutation(updateTicket);

   /*
  Funciones y Eventos
  */
   function Prioridad(prioridadNro) {
      let prioridad = '';
      if (prioridadNro === 0) prioridad = 'BAJA';
      else if (prioridadNro === 1) prioridad = 'MEDIA';
      else if (prioridadNro === 2) prioridad = 'ALTA';
      else if (prioridadNro === 3) prioridad = 'CRÍTICA';
      return prioridad;
   }

   async function validarTodos() {
      let ok = true;

      return ok;
   }
   function inicializar() {}
   const procesarGrabar = async () => {
      const ok = await validarTodos();
      if (ok) {
         procesar({
            variables: {
               ticket: ticket.codigo,
               estado: 3
            }
         });
      } else {
         handleOpen('Se han encontrado errores al validar los datos.');
      }
   };

   /**
    * Efectos procesar
    */
   useEffect(() => {
      if (!esVarNullUndef(dataP)) {
         props.setProcesarOK(true);
         inicializar();
      }
   }, [dataP]);
   //Manejo de errores de las consultas a la api
   useEffect(() => {
      let eMsg = '';
      if (!esVarNullUndef(errorP)) {
         eMsg = eMsg + JSON.stringify(errorP);
      }
      if (eMsg !== '') {
         handleOpen(eMsg);
      }
   }, [errorP]);

   return (
      <Card
      /*{...rest}
     className={clsx(classes.root, className)}*/
      >
         <CardHeader
            title={
               <Typography component="p" color="textPrimary" variant="h5">
                  Información de Ticket
               </Typography>
            }
            disableTypography={true}
            avatar={
               <Avatar className={classes.avatar}>
                  <LocalActivityIcon />
               </Avatar>
            }
            action={
               <IconButton aria-label="settings">
                  <KeyboardArrowUp />
               </IconButton>
            }
         />
         <Divider />
         <CardContent className={classes.content}>
            <Typography className={classes.locationText} color="textSecondary" variant="body1">
               {`${ticket.codigo}  -  ${ticket.asunto}`}
            </Typography>
            <Typography className={classes.locationText} color="textSecondary" variant="body1">
               {`Prioridad: ${Prioridad(ticket.prioridad)}`}
            </Typography>
            <Typography className={classes.locationText} color="textSecondary" variant="body1">
               {`Creado el: ${new Date(ticket.fecha).toLocaleDateString('es-PE', options)}`}
            </Typography>
         </CardContent>
         <Divider />
         <CardActions className={classes.actions}>
            {ticket.estado !== 3 ? (
               <Button variant="contained" color="primary" onClick={procesarGrabar}>
                  Cerrar
               </Button>
            ) : (
               <>
                  <Button variant="contained" disabled>
                     Cerrado
                  </Button>
               </>
            )}
         </CardActions>
      </Card>
   );
};

export default GeneralInformacion;
